import styled from "@emotion/styled";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { getStyles } from "src/styles/theme";
import defaultStyles from "./styles";

export type DashBoardTable = {
  topHeader: string[];
  header: string[];
  data: any;
};

export function EntityDashBoardTable({
  data,
  header,
  topHeader,
}: DashBoardTable) {
  const styles = getStyles(defaultStyles);

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 600 }} aria-label="simple table">
        <TableHead {...styles("header")}>
          <TableRow>
            {topHeader.map((item, index) => (
              <TableCell
                align="center"
                {...styles("cell")}
                key={index}
                colSpan={index ? 2 : 3}
              >
                {item}
              </TableCell>
            ))}
          </TableRow>
          <TableRow>
            {header.map((item, index) => (
              <TableCell align="center" {...styles("cell")} key={index}>
                {item}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, index) => {
            return (
              <TableRow>
                <TableCell align="center" {...styles("cell")}>
                  {row.sno}
                </TableCell>

                <TableCell align="center" {...styles("cell")}>
                  {row.entityName}
                </TableCell>
                <TableCell
                  align="center"
                  {...styles("cell", { width: "180px" })}
                >
                  {row.state}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.totalBlocks}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.totalBlocksArea}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.totalNumberOfGenerateDemandNote}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.totalAreaOfGenerateDemandNote}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.totalNumberOfVerificationPending}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.totalAreaOfVerificationPending}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.totalNumberOfDemandNotePending}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.totalAreaOfDemandNotePending}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.totalNumberOfDemandNoteReleased}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.totalAreaOfDemandNoteReleased}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.numberPaymentPending}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.areaPaymentPending}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.numberPaymentDone}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.areaPaymentDone}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
